import Nav from "./Nav"
import Footer from "./Footer"

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white">
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
